import { useCallback, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const API_BASE = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = 'ybv_auth_token';

function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

async function sendEvent(event, route, metadata) {
  const token = getToken();
  if (!token) return;
  try {
    await fetch(`${API_BASE}/api/analytics/event`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify({ event, route, metadata }),
    });
  } catch {
    // Silent fail — analytics should never break the app
  }
}

// Track a named event
export function trackEvent(event, metadata) {
  sendEvent(event, window.location.pathname, metadata);
}

// Hook: auto-track page_view on route change
export function usePageViewTracker() {
  const location = useLocation();
  const prev = useRef('');

  useEffect(() => {
    if (location.pathname !== prev.current) {
      prev.current = location.pathname;
      sendEvent('page_view', location.pathname, {});
    }
  }, [location.pathname]);
}

// Hook: track scenario changes
export function useScenarioTracker() {
  return useCallback((scenarioId) => {
    trackEvent('scenario_change', { scenario: scenarioId });
  }, []);
}
